module.exports = "https://redage.akamaized.net/src/views/player/help/images/tatoo2.jpg";